import React from "react";
import HeroSection from "../components/common/HeroSection";
import SectionTitle from "../components/common/SectionTitle";
import ClientLogos from "../components/home/ClientLogos";
import Partners from "../components/home/Partners";

const About = () => {
  return (
    <div className="about-page">
      <HeroSection
        title="About Us"
        breadcrumb={[{ name: "About Us" }]}
        background="/assets/images/banner.jpg"
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col-reverse lg:flex-row">
            <div className="lg:w-1/3 mt-10 lg:mt-0 lg:pr-12">
              <div className="relative">
                <img
                  src="/assets/images/about/about-three-1.jpg"
                  alt="About TISSA"
                  className="rounded-lg shadow-lg mb-8"
                />
                <img
                  src="/assets/images/about/about-three-2.jpg"
                  alt="About TISSA"
                  className="rounded-lg shadow-lg"
                />
                <div className="absolute right-0 bottom-0 w-48 h-48 bg-blue-600 rounded-full opacity-10 -z-10 transform translate-x-1/4 translate-y-1/4"></div>
              </div>
            </div>

            <div className="lg:w-2/3">
              <SectionTitle
                subtitle="About Our Company"
                title="We are Professional in IT Solutions and Services"
                align="left"
              />

              <div className="prose text-justify max-w-none text-gray-600">
                <p>
                  Established in 2016 and headquartered in Texas, TISSA
                  Technology LLC was founded by highly experienced professionals
                  committed to providing comprehensive IT and digital solutions
                  under one roof. With cutting-edge technology and a team of
                  knowledgeable, skilled experts, we deliver user-friendly,
                  customized solutions tailored to our clients' unique needs.
                </p>
                <br />

                <p>
                  We empower organizations across all industries to gain
                  momentum by supporting their IT infrastructure and hardware
                  requirements. Leveraging advanced technologies such as
                  Cryptocurrency, IoT, Big Data, and Mobile Applications, we
                  develop innovative software products and build long-term
                  strategic partnerships with our clients.
                </p>
                <br />

                <p>
                  <strong>TISSA Technology</strong> is a leading provider of
                  application and software development services, offering
                  professional mobile app and web development solutions
                  worldwide. Partnering with the right offshore software
                  development company can be a game-changer for your
                  business—and we aim to be that partner.
                </p>
                <br />

                <p>
                  We deliver high-quality, custom web designs at affordable
                  prices and have created thousands of engaging, creative
                  websites for clients across various industries. Our work is
                  not only visually appealing but also strategically designed to
                  promote your brand and communicate your message effectively.
                </p>
                <br />

                <p>
                  Recognized as one of the top software development companies in
                  Texas, <strong>TISSA Technology</strong> offers a wide range
                  of services, including desktop, web, and mobile app
                  development, quality assurance testing, and DevOps. As one of
                  the top Houston software development companies, we continue to
                  provide globally delivered solutions that meet the highest
                  standards of quality and innovation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Partners />
      <ClientLogos />
    </div>
  );
};

export default About;
